import { MODAL_TYPE_SHAREHOLDER } from '../../modalShareholder';
import ModalShareholderContainer from '../../modalShareholder/containers/modal-shareholder-container';

export const MODAL_COMPONENTS = {
  [MODAL_TYPE_SHAREHOLDER]: ModalShareholderContainer,
};
